import { IEmployeeBudget } from '@/common/integrations/menhir/employee/budgets/budgets.types';
import { IMovement } from '@/common/integrations/menhir/employee/movements/movements.types';

export function shouldTreatAsExpired(employeeBudget: IEmployeeBudget): boolean {
  return (
    employeeBudget.status === 'expired' || employeeBudget.status === 'removed'
  );
}

export const budgetTopupTypes: Array<IMovement['subcategory']> = [
  'top_up',
  'accrual_recurrent_top_up',
  'no_accrual_recurrent_top_up',
];
